import { z } from 'zod'
import { requiredString, timestampedDocSchema } from '../utils/basicSchemas/document.z.schema'
import { mongoId, mongoIdSchema } from '../utils/basicSchemas/_id.z.schema'
import { ZSchema } from '../utils/zodSchema'

// Enums 
const subOptionEnum = [
    'DefaultInput',
    'IconLeftInput',
    'IconRightInput',
    'IconLeftInteractiveInput',
    'IconRightInteractiveInput',
    'InfoRightInput',
    'InfoLeftInput',
    'TextLeftInput',
    'TextRightInput',
    'SideOptions',
    'EditDefaultLabelInput',
    'EditLargeLabelInput',
    'LargeTextInput',
    'LinkInput',
    'MultiSelectDropdown',
    'WithOptionInput',
    'WithOptionIconLeftInput',
    'DefaultDropdown',
    'IconLeftDropdown',
    'InfoRightDropdown',
    'InfoRightWithParagraphDropdown',
    'DateDropdown',
    'DateRangeDropdown',
    'SearchDropdown',
    'SearchIconLeftDropdown',
    'WithParagraphDropdown',
    'WithIconDropdown'
]

const typesEnum = ['string', 'number', 'boolean', 'object', 'array'] as const

// Enum schemas 
//@ts-ignore
const DataFieldComponentSchema = z.enum(subOptionEnum).nullable()
const typesEnumSchema = z.enum(typesEnum).nullable()

// Partial schemas 

/**
 * Partial to subcatInputConfigSchema
 */
const propsSchema = z.object({
    value: z.string(),
    caption: z.string().optional(),
    label: z.string().optional(),
    placeholder: z.string().optional(),
    options: z.array(z.any()).optional(),
    type: typesEnumSchema,
})

/**
 * Partial to subCategorySchema
 */
export const subcatInputConfigSchema = z.object({
    component: DataFieldComponentSchema,
    props: propsSchema.optional(),
    options: z.array(z.unknown()).optional(),
    isCustom: z.boolean().optional().default(false),
    isExtra: z.boolean().optional().default(false),
    show: z.boolean().optional().default(true),
})

/**
 * Full schema for a sub category
 */
const subCategorySchema = z.object({
    name: requiredString("Subcategory Name"),
    description: z.string().optional().nullable().default(null),
    category: mongoId("Subcategory Category"),
    categoryName: requiredString("Subcategory categoryName"),
    createdBy: mongoIdSchema.optional(),
    values: z.record(z.array(subcatInputConfigSchema)),
})



const subCategoryApiReturnStructureSchema = timestampedDocSchema.merge(subCategorySchema.extend({
    postsWithin: z.number(),
}))

type subCategoryApiReturnStructure = z.infer<typeof subCategoryApiReturnStructureSchema>


// Getting used 
const subCategoryCreationSchema = z.object({
    name: requiredString("Subcategory Name"),
    description: z.string().optional().nullable().default(null),
    category: mongoId("Subcategory Category"),
    categoryName: requiredString("Parent Category name"),
    values: z.record(z.array(subcatInputConfigSchema)),
    hidden: z.boolean()
})

// Getting used 
const subCategoryUpdateSchema = z.object({
    updates: z.object({
        name: requiredString("Subcategory Name"),
        description: z.string().optional().nullable().default(null),
        category: mongoId("Subcategory Category"),
        categoryName: requiredString("Parent Category name"),
        values: z.record(z.array(subcatInputConfigSchema)).optional(),
    })
})

// Schema for validating subcategory ID.
const subCategoryIdSchema = z.object({
    id: mongoId("Subcategory id"),
})


// Type inference exports
type SubCategorySchemaType = z.infer<typeof subCategorySchema>
type DataFieldComponentType = z.infer<typeof DataFieldComponentSchema>
type subcatInputConfigType = z.infer<typeof subcatInputConfigSchema>
type typesEnumType = z.infer<typeof typesEnumSchema>



const subcategoryIdValidator = new ZSchema({ paramSchema: subCategoryIdSchema })
const subcategoryValidator = new ZSchema({ bodySchema: subCategoryCreationSchema })
const subcategoryUpdateValidator = new ZSchema({
    bodySchema: subCategoryUpdateSchema, paramSchema: subCategoryIdSchema
})
export { typesEnum, subOptionEnum }
export { subCategorySchema }
export { subcategoryIdValidator, subcategoryValidator, subcategoryUpdateValidator }
export type { SubCategorySchemaType, subCategoryApiReturnStructure, typesEnumType, subcatInputConfigType, DataFieldComponentType }

